import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import animationData from '../../lotties/coins.json';
import Lottie from 'react-lottie';
import SiteLayout from '../SiteLayout';
import Typo from '../components/Typo';



const SelectPlan = () => {

    const { t, } = useTranslation();
    const theme = useTheme()
    const pageCode = 'startOnboard';
    const tableRef = useRef(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);



    const websiteData = useSelector((state) => state.website.data);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
            progressiveLoad: false,
        },
    };

    useEffect(() => {
        if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v3/pricing-table.js';
            script.async = true;
            document.body.appendChild(script);
        }

        const timeout = setTimeout(() => {
            if (tableRef.current) {
                tableRef.current.innerHTML = `
              <stripe-pricing-table
                pricing-table-id="prctbl_1R5SKU039uUr8lBdi2dGQUo0"
                publishable-key="pk_live_51PpVVc039uUr8lBdyHrPXPgJbBDldnuBHEMqvbu3I0q05aWx5lQQrVpUEuo3qGEtWcSjx3TFkjdDHr0RYOKbn0fZ0029TBJ0u4">
              </stripe-pricing-table>
            `;
            }
        }, 500);

        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        return () => {
            setIsAnimationPlaying(false);
        };
    }, []);


    const customPricingData = [
        { item: t('tags'), description: t('tagsDesc'), price: '0.80$', per: t('MA') },
        { item: t('qrCode'), description: t('qrCodeDesc'), price: '0.00$', per: t('label') },
        { item: t('operations'), description: t('operationsDesc'), price: '1.00$', per: t('1000ops') },
        { item: t('emails'), description: t('emailsDesc'), price: '1.00$', per: t('1000ops') },
        { item: t('storage'), description: t('storageDesc'), price: '1.00$', per: t('GB') },
        { item: t('extensions'), description: t('extensionsDesc'), price: 'Variable', per: t('monthFixed') },
        { item: t('changesRequested'), description: t('changesRequestedDesc'), price: '99.00$', per: t('block') },
        { item: t('customization'), description: t('customizationDesc'), price: 'Variable', per: '' },
        { item: t('APIActions'), description: t('APIActionsDesc'), price: '10.00$', per: t('10000ops') },
    ];


    return (
        <SiteLayout
            helmetData={{
                name: t(pageCode + 'SEO'),
                description: t(pageCode + 'SEODesc'),
            }}
        >   <div className='container'>
                <div className="block-separator row">

                    <div className="mt-5 col-md-6 col-12">
                        <Typo
                            variant="h1"
                            text={t(pageCode + 'headerTitle')}
                        />
                        <Typo
                            variant="body1"
                            text={t(pageCode + 'headerSubTextTitle')}
                            className="mt-5"
                        />
                        <Typo
                            variant="body2"
                            className="mt-3"
                            text={t(pageCode + 'headerSubTextTitle2')}
                        />

                    </div>
                    <div className="col-md-6 col-12 align-c mb-4">
                        <div
                            style={{
                                zIndex: 0,
                                left: 0,
                                bottom: 0,

                            }}
                        >
                            {isAnimationPlaying && (
                                <Lottie
                                    options={defaultOptions}
                                    height={isMobile ? 330 : 460}
                                    width={isMobile ? 350 : 500}
                                    isStopped={!isAnimationPlaying}
                                    isPaused={!isAnimationPlaying}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ backgroundColor: '#FFFFFF', paddingTop: '50px', paddingBottom: '50px' }} className="align-c px-5">
                <Typo
                    variant="h2"
                    className="mt-5 px-5"
                    text={websiteData?.pricing?.headerSec2Title || t('headerSec2Title')}
                />
                <Typo
                    className="mt-3"
                    variant="smallTitle"
                    text={
                        websiteData?.pricing?.headerSec2SubTitle ||
                        t('headerSec2SubTitle')
                    }
                />
            </div>

            <div style={{ paddingBottom: '50px' }} ref={tableRef} />

            {/* New Custom Pricing Table Section */}
            <div className='container' style={{ paddingBottom: '120px', paddingTop: '50px', maxWidth: '750px' }}>
                <Typo
                    variant="h2"
                    className="mt-5 px-5"
                    text={t('usageFees')}
                />
                <div>
                    <Typo
                        variant="body2"
                        className="mt-3 px-5"
                        text={t('usageFeesDesc')}
                    />
                </div>
                <TableContainer elevation={0} component={Paper} sx={{ maxWidth: 650, margin: 'auto', marginTop: 3, borderRadius: '10px' }}>
                    <Table aria-label="custom pricing table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('name')}</TableCell>
                                <TableCell align="right">{t('price')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customPricingData?.map((row) => (
                                <TableRow key={row.item}>
                                    <TableCell component="th" scope="row">
                                        <div> {row.item}</div>
                                        <div className="fs-10"> {row.description}</div>
                                    </TableCell>
                                    <TableCell align="right"><div className='fw-600'>{row.price}</div><div className='greyText fs-10'>{(row?.per ? ` / ${row.per}` : '')}</div></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </SiteLayout>

    );
};

export default SelectPlan;
